import { runningTradeAction } from 'constants/datafeed';
import InfiniteScroll from 'global/InfiniteScroll';
import { CSSProperties } from 'react';
import Link from 'next/link';
import { TdPrice, TdAction, TableInitWrapper, TdBroker } from './styled';
import RunningTradeEmpty from './RunningTradeEmpty';
import ThSort from './ThSort';

type RunningTradeInitTableProps = {
  id?: string;
  data: GetInitRunningTradeItem[];
  showAction?: boolean;
  showCode?: boolean;
  hasMore: boolean;
  loadMore: () => void;
  isLoadingMore?: boolean;
  height: CSSProperties['height'];
  handleTableSort?: (
    field?: GetInitRunningTradeOrderBy,
    order?: GetInitRunningTradeSort,
  ) => void;
  defaultSort?: {
    key: GetInitRunningTradeOrderBy;
    direction: GetInitRunningTradeSort;
  };
};

const actionEnum = {
  buy: 1,
  sell: 2,
};

function RunningTradeInitTable({
  id,
  data,
  showAction = false,
  showCode = false,
  hasMore,
  loadMore,
  isLoadingMore,
  height,
  handleTableSort,
  defaultSort,
}: RunningTradeInitTableProps) {
  const headerColumns = [
    <ThSort
      style={{ width: data.length ? '68.72px' : undefined }}
      sortKey="ORDER_BY_TIME"
      sortState={defaultSort}
      onSort={handleTableSort}
    >
      Time
    </ThSort>,
    ...(showCode ? [<th style={{ width: '50px' }}>Code</th>] : []),
    <th style={{ width: data.length ? '85.67px' : undefined }}>Price</th>,
    ...(showAction ? [<th>Action</th>] : []),
    <ThSort
      sortKey="ORDER_BY_LOT"
      sortState={defaultSort}
      onSort={handleTableSort}
    >
      Lot
    </ThSort>,
    <th>Buyer</th>,
    <th>Seller</th>,
  ];

  return (
    <TableInitWrapper
      className={id}
      style={{ height: data.length > 0 ? height : undefined }}
    >
      <table style={{ minWidth: data.length > 0 ? 382 : undefined }}>
        <thead>{headerColumns}</thead>
        <tbody>
          {data.length > 0 ? (
            data.map((x, index, a) => (
              <tr key={x.trade_number}>
                <td>{x.time}</td>
                {showCode && (
                  <td className="company-code">
                    <Link href={`/symbol/${x.code}`}>
                      <a target="_blank">{x.code}</a>
                    </Link>
                  </td>
                )}
                <td>
                  <TdPrice
                    type={x.action}
                    change={parseFloat(x.change)}
                    isColored
                  >
                    {x.price}({x.change})
                    {index === a.length - 10 && (
                      <InfiniteScroll
                        style={{ display: 'inline' }}
                        hasMore={hasMore}
                        refineNext={loadMore}
                        loader={null}
                        isLoading={isLoadingMore}
                      />
                    )}
                  </TdPrice>
                </td>
                {showAction && (
                  <td>
                    <TdAction type={actionEnum[x.action]} isColored>
                      {runningTradeAction[actionEnum[x.action]]}
                    </TdAction>
                  </td>
                )}
                <td>{x.lot}</td>
                <TdBroker type={x.buyer_type}>{x.buyer}</TdBroker>
                <TdBroker type={x.seller_type}>{x.seller}</TdBroker>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={headerColumns.length}>
                <RunningTradeEmpty />
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </TableInitWrapper>
  );
}

export default RunningTradeInitTable;
